module.exports = __webpack_public_path__ + "files/SPIADI2026 - EXP ADI - Fiche Bactériémie.30b06cd646961b892a5dd64826cbecb9.pdf";